import { isEmpty, sumBy } from 'lodash';
import {
  ADD_BANK,
  AUTOMATIC_LANDING,
  BUY_TRANSACTION,
  APP_BUY_TRANSACTION,
  APP_SELL_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  EXCHANGE_TRANSACTION,
  LANDING,
  RECURRING_BUY_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  RECURRING_BUY_TRANSACTION_EDIT,
  RECURRING_EXCHANGE_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION_EDIT,
  SELL_TRANSACTION,
  TransactionTypes,
  TRANSACTION_LANDING,
  ROTH_CONVERSION_DEFAULT_MIN,
  ROTH_CONVERSION_DEFAULT_MAX,
} from '../settings/settings';
import { appendBasePath } from './nav.utils';
import { coalesce } from './utils';
import { PendingTransaction } from '../redux/modules/pendingTransactions/types';
export {
  AUTOMATIC_LANDING,
  ADD_BANK,
  BUY_TRANSACTION,
  APP_BUY_TRANSACTION,
  APP_SELL_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  SELL_TRANSACTION,
  EXCHANGE_TRANSACTION,
  RECURRING_BUY_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION_EDIT,
  RECURRING_BUY_TRANSACTION_EDIT,
  TRANSACTION_LANDING,
  LANDING,
};
export const AUTOMATIC_SELL_TRANSACTION = 'AUTOMATIC_SELL_TRANSACTION';
export const AUTOMATIC_SELL_TRANSACTION_EDIT =
  'AUTOMATIC_SELL_TRANSACTION_EDIT';
export const ROTH_CONVERSION = 'ROTH_CONVERSION';
export const QCD_ENTRY = 'QCD_ENTRY';
export const QCD_TRANSACTION = 'QCD_TRANSACTION';
export const TRADE_DATE_TOOLTIP =
  'For most funds, trades received after the close of regular trading on the New York Stock Exchange ' +
  "(usually 4 p.m. ET) will be priced at the next business day's close. " +
  "For Government Money Fund and U.S. Treasury Money Fund, trades in and out of these funds and exchanges solely between these funds received after the fund's close" +
  "(normally 5 p.m. ET) will be priced at the next business day's close.";

let cachedTransactionType;

function testPath(part) {
  return window?.location.pathname.toLowerCase().includes(part);
}

export function isBuy() {
  return (
    testPath(appendBasePath('/buy')) ||
    testPath(appendBasePath('/salesforce/buy'))
  );
}

export function isCollegeAnything() {
  return (
    testPath(appendBasePath('/college/')) ||
    testPath(appendBasePath('/salesforce/college'))
  );
}

export function isCollegeContribute() {
  return (
    testPath(appendBasePath('/college/contribute')) ||
    testPath(appendBasePath('/salesforce/college/contribute'))
  );
}

export function isCollegeDistribute() {
  return (
    testPath(appendBasePath('/college/distribute')) ||
    testPath(appendBasePath('/salesforce/college/distribute'))
  );
}

export function isCollegeExchange() {
  return (
    testPath(appendBasePath('/college/exchange')) ||
    testPath(appendBasePath('/salesforce/college/exchange'))
  );
}

export function isExchange() {
  return (
    (testPath(appendBasePath('/exchange')) ||
      testPath(appendBasePath('/salesforce/exchange'))) &&
    !isCollegeExchange()
  );
}
export function isSell() {
  return (
    testPath(appendBasePath('/sell')) ||
    testPath(appendBasePath('/salesforce/sell'))
  );
}

export function isLanding() {
  return (
    testPath(appendBasePath('/automatic')) ||
    testPath(appendBasePath('/salesforce/automatic'))
  );
}

export function isTransactionLanding() {
  return (
    testPath(appendBasePath('/landing')) ||
    testPath(appendBasePath('/salesforce/landing'))
  );
}

export function isAddBank() {
  return (
    testPath(appendBasePath('/addbank')) ||
    testPath(appendBasePath('/salesforce/addbank'))
  );
}

export function isIRAAutoMax() {
  return (
    testPath(appendBasePath('/automatic/ira-automax')) ||
    testPath(appendBasePath('/salesforce/automatic/ira-automax')) ||
    testPath(appendBasePath('/automatic/ira-automax/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/ira-automax/edit'))
  );
}

export function isRecurringBuy() {
  return (
    testPath(appendBasePath('/automatic/buy')) ||
    testPath(appendBasePath('/salesforce/automatic/buy')) ||
    testPath(appendBasePath('/automatic/contribute')) ||
    testPath(appendBasePath('/salesforce/automatic/contribute'))
  );
}

export function isRecurringBuyEdit() {
  return (
    testPath(appendBasePath('/automatic/buy/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/buy/edit')) ||
    testPath(appendBasePath('/automatic/contribute/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/contribute/edit'))
  );
}

export function isRecurringContribute() {
  return (
    testPath(appendBasePath('/automatic/contribute')) ||
    testPath(appendBasePath('/salesforce/automatic/contribute'))
  );
}

export function isAutoExchange() {
  return (
    testPath(appendBasePath('/automatic/exchange')) ||
    testPath(appendBasePath('/salesforce/automatic/exchange'))
  );
}

export function isAutoExchangeEdit() {
  return (
    testPath(appendBasePath('/automatic/exchange/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/exchange/edit'))
  );
}

export function isRecurringContributeEdit() {
  return (
    testPath(appendBasePath('/automatic/contribute/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/contribute/edit'))
  );
}

export function isAutomaticSell() {
  return (
    testPath(appendBasePath('/automatic/sell')) ||
    testPath(appendBasePath('/salesforce/automatic/sell'))
  );
}

export function isAutomaticSellEdit() {
  return (
    testPath(appendBasePath('/automatic/sell/edit')) ||
    testPath(appendBasePath('/salesforce/automatic/sell/edit'))
  );
}

export function isAppBuy() {
  return (
    testPath(appendBasePath('/advisory/add')) ||
    testPath(appendBasePath('/salesforce/advisory/add')) ||
    testPath(appendBasePath('/app/add')) ||
    testPath(appendBasePath('/salesforce/app/add'))
  );
}

export function isAppSell() {
  return (
    testPath(appendBasePath('/app/withdraw')) ||
    testPath(appendBasePath('/advisory/withdraw'))
  );
}

export function isRothConversion() {
  return (
    testPath(appendBasePath('/roth-conversion')) ||
    testPath(appendBasePath('/salesforce/roth-conversion'))
  );
}

export function isQCD() {
  return (
    testPath(appendBasePath('/qcd')) ||
    testPath(appendBasePath('/salesforce/qcd'))
  );
}

export function isQCDLanding() {
  return (
    testPath(appendBasePath('/qcd/landing')) ||
    testPath(appendBasePath('/salesforce/qcd/landing'))
  );
}

export function transactionType() {
  if (!cachedTransactionType) {
    cachedTransactionType = isBuy()
      ? BUY_TRANSACTION
      : isSell()
      ? SELL_TRANSACTION
      : isAppBuy()
      ? APP_BUY_TRANSACTION
      : isAppSell()
      ? APP_SELL_TRANSACTION
      : isCollegeExchange()
      ? COLLEGE_EXCHANGE_TRANSACTION
      : isCollegeContribute()
      ? COLLEGE_CONTRIBUTE_TRANSACTION
      : isRecurringBuyEdit()
      ? RECURRING_BUY_TRANSACTION_EDIT
      : isRecurringBuy()
      ? RECURRING_BUY_TRANSACTION
      : isIRAAutoMax()
      ? IRA_AUTOMAX_TRANSACTION
      : isAutomaticSell()
      ? AUTOMATIC_SELL_TRANSACTION
      : isAutomaticSellEdit()
      ? AUTOMATIC_SELL_TRANSACTION_EDIT
      : isAutoExchange()
      ? RECURRING_EXCHANGE_TRANSACTION
      : isAutoExchangeEdit()
      ? RECURRING_EXCHANGE_TRANSACTION_EDIT
      : isCollegeDistribute()
      ? COLLEGE_DISTRIBUTE_TRANSACTION
      : isExchange()
      ? EXCHANGE_TRANSACTION
      : isLanding()
      ? AUTOMATIC_LANDING
      : isTransactionLanding()
      ? LANDING
      : isAddBank()
      ? ADD_BANK
      : isRothConversion()
      ? ROTH_CONVERSION
      : isQCD()
      ? QCD_TRANSACTION
      : isQCDLanding()
      ? QCD_ENTRY
      : null;
  }
  return cachedTransactionType;
}

export function isTransactionOneOf(...transactionTypes) {
  return transactionTypes.includes(transactionType());
}

export function getAPITransactionType(type = 'Purchase') {
  switch (transactionType()) {
    case BUY_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case APP_BUY_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case APP_SELL_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case IRA_AUTOMAX_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case RECURRING_BUY_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case RECURRING_BUY_TRANSACTION_EDIT:
      type = TransactionTypes.BUY;
      break;
    case EXCHANGE_TRANSACTION:
      type = TransactionTypes.EXCHANGE;
      break;
    case RECURRING_EXCHANGE_TRANSACTION:
      type = TransactionTypes.EXCHANGE;
      break;
    case SELL_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case AUTOMATIC_SELL_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case AUTOMATIC_SELL_TRANSACTION_EDIT:
      type = TransactionTypes.SELL;
      break;
    case COLLEGE_CONTRIBUTE_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case COLLEGE_DISTRIBUTE_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case COLLEGE_EXCHANGE_TRANSACTION:
      type = TransactionTypes.EXCHANGE;
      break;
    case AUTOMATIC_LANDING:
      type = TransactionTypes.AUTOMATIC_SELL;
      break;
    case LANDING:
      type = TransactionTypes.SELL;
      break;
    case ADD_BANK:
      type = TransactionTypes.BUY;
      break;
    case ROTH_CONVERSION:
      type = TransactionTypes.EXCHANGE;
      break;
    case QCD_ENTRY:
      type = TransactionTypes.SELL;
      break;
    case QCD_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    default:
      console.error(
        'Unexpected transaction type for getPersonalInformation: ' +
          transactionType()
      );
      type = TransactionTypes.BUY;
  }
  return type;
}
/**
 * Given an object with vales based on transaction type, returns the appropriate value. Example,
 * transactionTypeSelect({ [BUY_TRANSACTION]: 'Purchase', [EXCHANGE_TRANSACTION]: 'Exchange' });
 *
 * @param {Object.<String, any>} options
 * @returns {*}
 */
export function transactionTypeSelect(options) {
  return coalesce(options[transactionType()], '');
}

export function getFundLimit({ selectedFund, userRegistrationTypeInfo }) {
  const {
    selectedRegistrationType: { currentYearLimit },
  } = userRegistrationTypeInfo;

  if (isEmpty(currentYearLimit)) {
    return 0;
  }
  const targetType = transactionTypeSelect({
    [BUY_TRANSACTION]: 'PURCHASE',
    [COLLEGE_CONTRIBUTE_TRANSACTION]: 'PURCHASE',
    [EXCHANGE_TRANSACTION]: 'EXCHANGE',
    [COLLEGE_EXCHANGE_TRANSACTION]: 'EXCHANGE',
    [ROTH_CONVERSION]: 'EXCHANGE',
  });

  const limit = currentYearLimit.filter((obj) => obj.type === targetType);
  if (isEmpty(limit)) {
    return 0;
  }
  return limit[0].minimum || selectedFund.minimumInvestmentAmount;
}

/**
 * Checks for existing roth IRA registration,
 * if one doesn't exist, will create a mock one using traditional ira registration info
 * @param {UserRegistration[]}
 * @returns {UserRegistration}
 */
export const getRothIRARegistration = (userRegistrationTypes) => {
  const rothIRA = userRegistrationTypes.find(
    (r) => r.agreementType === 'ROTH_IRA'
  );

  const traditionalIRA = userRegistrationTypes.find(
    (r) => r.agreementType === 'TRADITIONAL_IRA'
  );

  return (
    rothIRA || {
      ...traditionalIRA,
      existingTickers: [],
      modelAgreementUniqueIDs: [],
      agreementType: 'ROTH_IRA',
      currentYearLimit: [
        {
          type: 'EXCHANGE',
          minimum: ROTH_CONVERSION_DEFAULT_MIN,
          maximum: ROTH_CONVERSION_DEFAULT_MAX,
        },
      ],
    }
  );
};

export const getPendingTransactionTotalForFund = (
  fund,
  pendingTransactions
) => {
  if (!pendingTransactions) {
    return 0;
  }
  const associatedSellPendingTransactions = pendingTransactions.filter(
    (p) =>
      fund.agreementID ===
        p.transactionRecord.sourcePositionKey.agreementKey.agreementID ||
      fund.agreementNumber ===
        p.transactionRecord.sourcePositionKey.agreementKey.agreementNumber
  );
  const pendingTransactionTotalForFund = associatedSellPendingTransactions
    ? sumBy(
        associatedSellPendingTransactions,
        (a: PendingTransaction) => a.transactionRecord.amount
      )
    : 0;
  return pendingTransactionTotalForFund;
};

export const getExchangeTradeDatesObject = ({ exchangeTradeDates = [] }) => {
  const tradeDates = {
    toFunds: {},
    fromFunds: {},
  };
  exchangeTradeDates.forEach((item) => {
    tradeDates.fromFunds[item['sourceAgreementId']] =
      item['estimatedTradeDate'];
    tradeDates.toFunds[item['targetAgreementId']] = item['estimatedTradeDate'];
  });

  return tradeDates;
};
